import React from "react";
import { Link } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
import Header, { PrimaryLink } from "components/headers/light.js";
import { SecondaryCtaLink } from "components/misc/Buttons.js";

const Container = tw.div`relative bg-gray-100`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-16 md:py-20 px-4 sm:px-8`;
const LeftColumn = tw.div`relative lg:w-1/2 text-center lg:text-left`;
const RightColumn = tw.div`relative mt-10 lg:mt-0 lg:w-1/2 flex justify-center lg:justify-end`;
const WideImageWrap = tw.div`max-w-screen-xl mx-auto px-4 sm:px-8 pb-12 md:pb-16`;

const Badge = tw.span`inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-sm font-bold uppercase tracking-wide`;
const Heading = tw.h1`mt-4 font-black text-3xl md:text-4xl lg:text-5xl text-gray-900 leading-tight`;
const Tagline = tw.p`mt-4 text-base md:text-lg text-secondary-100 leading-relaxed max-w-xl mx-auto lg:mx-0`;
const Actions = tw.div`mt-8 flex flex-col sm:flex-row items-stretch sm:items-center lg:items-start justify-center lg:justify-start gap-4`;
const HeroImage = styled.img`
  ${tw`w-full rounded-lg shadow-xl`}
  ${(props) => (props.$wide ? tw`max-w-full object-contain` : tw`max-w-md lg:max-w-lg`)}
`;
const WideFrame = styled.div`
  ${tw`rounded-lg overflow-hidden bg-white shadow-lg p-4 md:p-6 flex items-center justify-center`}
`;

export default ({
  badge,
  title,
  tagline,
  heroImage,
  heroImageLayout = "side",
  primaryCtaText,
  primaryCtaUrl,
  secondaryCtaText,
  secondaryCtaUrl,
}) => {
  const isExternal = (url) => url && (url.startsWith("http") || url.startsWith("#"));

  return (
    <>
      <Header roundedHeaderButton={true} />
      <Container>
        <TwoColumn>
          <LeftColumn>
            {badge && <Badge>{badge}</Badge>}
            <Heading>{title}</Heading>
            {tagline && <Tagline>{tagline}</Tagline>}
            <Actions>
              {primaryCtaText && primaryCtaUrl && (
                <PrimaryLink href={primaryCtaUrl}>{primaryCtaText}</PrimaryLink>
              )}
              {secondaryCtaText && secondaryCtaUrl &&
                (isExternal(secondaryCtaUrl) ? (
                  <SecondaryCtaLink href={secondaryCtaUrl}>{secondaryCtaText}</SecondaryCtaLink>
                ) : (
                  <SecondaryCtaLink as={Link} to={secondaryCtaUrl}>{secondaryCtaText}</SecondaryCtaLink>
                ))}
            </Actions>
          </LeftColumn>
          {heroImage && heroImageLayout === "side" && (
            <RightColumn>
              <HeroImage src={heroImage} alt={title} />
            </RightColumn>
          )}
        </TwoColumn>
        {heroImage && heroImageLayout === "wide" && (
          <WideImageWrap>
            <WideFrame>
              <HeroImage $wide src={heroImage} alt={title} />
            </WideFrame>
          </WideImageWrap>
        )}
      </Container>
    </>
  );
};
